import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Helmet } from "react-helmet";
import "./App.css";
import NavBar from './components/NavBar';
import Home from './components/Home';
import Footer from './components/Footer';
import Products from './components/Pages/Products';
import Contact from './components/Pages/Contact';
import About from './components/Pages/About';

import { calculatorRoutes } from './routes';

// Create lazy-loaded component wrapper
const CalculatorRoute = ({ componentName, title, description, keywords }) => {
  const CalculatorComponent = lazy(() => import(`./components/Pages/${componentName}`));
  
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
      </Helmet>
      <Suspense fallback={<LoadingSpinner />}>
        <CalculatorComponent />
      </Suspense>
    </>
  );
};

// Loading spinner component
const LoadingSpinner = () => (
  <div className="loading-spinner">
    <div className="spinner"></div>
    <p>Loading calculator...</p>
  </div>
);

// Static route components - FIXED!
const HomeRoute = () => (
  <>
    <Helmet>
      <title>D-TechStudios - AI SaaS & Innovation Products | In-House Software Development</title>
      <meta name="description" content="D-TechStudios builds AI-powered SaaS products entirely in-house. We create intelligent automation tools, streamline workflows, and give you back your time. No outsourcing. Full ownership." />
      <meta name="keywords" content="D-TechStudios, AI SaaS, in-house development, AI automation, software studio, productivity tools, intelligent software, innovation products, custom SaaS" />
    </Helmet>
    <Home />
  </>
);

const ProductsRoute = () => (
  <>
    <Helmet>
      <title>Our Products - D-TechStudios | AI SaaS & Automation Tools</title>
      <meta name="description" content="Explore D-TechStudios' portfolio of AI-powered SaaS products. Built entirely in-house: AI automation, productivity tools, and intelligent software solutions." />
      <meta name="keywords" content="D-TechStudios products, AI SaaS, automation tools, software portfolio, in-house development, AI products, productivity software" />
    </Helmet>
    <Products /> 
  </>
);

const ContactRoute = () => (
  <>
    <Helmet>
      <title>Contact Us - D-TechStudios | AI SaaS Studio Inquiries</title>
      <meta name="description" content="Get in touch with D-TechStudios for inquiries about our AI SaaS products, partnership opportunities, or general questions. We'd love to hear from you." />
      <meta name="keywords" content="contact D-TechStudios, AI SaaS inquiries, software studio contact, partnership opportunities, feedback, D-TechStudios support" />
    </Helmet>
    <Contact />
  </>
);

const AboutRoute = () => (
  <>
    <Helmet>
      <title>About Us - D-TechStudios | AI SaaS & Innovation Studio</title>
      <meta name="description" content="Learn about D-TechStudios, an independent AI SaaS studio building intelligent automation products entirely in-house. Meet our team, our mission, and our commitment to transparency." />
      <meta name="keywords" content="About D-TechStudios, AI SaaS studio, in-house development team, innovation studio, software company, D-TechStudios team, mission and values" />
    </Helmet>
    <About /> 
  </>
);

function App() {
  return (
    <>
      <BrowserRouter>
        <NavBar />
        <div className="pages">
          <Suspense fallback={<LoadingSpinner />}>
            <Routes>
              {/* Static Routes */}
              <Route path="/" element={<HomeRoute />} />
              <Route path="/Products" element={<ProductsRoute />} />
              <Route path="/Contact" element={<ContactRoute />} />
              <Route path="/About" element={<AboutRoute />} />
              
              {/* Dynamic Calculator Routes */}
              {calculatorRoutes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    <CalculatorRoute
                      componentName={route.component}
                      title={route.title}
                      description={route.description}
                      keywords={route.keywords}
                    />
                  }
                />
              ))}
            </Routes>
          </Suspense>
        </div>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;